'use client';

import { useEffect, useState } from 'react';

import { type Nullable } from 'corgi-types';
import CommonDrawer from 'corgi/common-drawer/components/CommonDrawer';
import CommonVisualNavigation from 'corgi/common-visual-navigation/components/CommonVisualNavigation';
import { Grid, GridItem } from 'corgi/common/components/Grid';
import { useGQLLocale } from 'corgi/common/hooks/locale';
import { useAppDomain } from 'corgi/common/providers/AppDomainProvider';
import GlobalHead from 'corgi/global-head/components/GlobalHead';
import type { GlobalNavigationProps } from 'frontend-utils/global-nav';

import { LogoutBanner } from '@components/common/fragments/AutoLogoutBanner';
import Footer from '@components/common/fragments/Footer';
import Header from '@components/common/fragments/Header';
import visualNavigationStatic from '@static/visual-navigation.json';
import ErrorBody from '../components/common/body/ErrorBody';

export default function ErrorPage() {
  const locale = useGQLLocale() as keyof typeof visualNavigationStatic;
  const appDomain = useAppDomain();
  const [hasError, setHasError] = useState(false);
  const [globalNavProps, setGlobalNavProps] = useState<Nullable<GlobalNavigationProps>>(null);

  useEffect(() => {
    if (globalNavProps) {
      return;
    }

    import(`../static/global-navigation/${locale}.json`)
      .then(data => setGlobalNavProps(data))
      .catch(() => setHasError(true));
  }, [globalNavProps, locale]);

  const visualNavigationProps = visualNavigationStatic[locale];

  if (!globalNavProps) {
    return hasError ? 'Internal server error' : null;
  }

  return (
    <>
      <GlobalHead baseUrl={appDomain} />

      <LogoutBanner />
      <Header {...globalNavProps} />
      <CommonDrawer />

      <ErrorBody />

      <Grid>
        <GridItem pt="sp_16">
          <CommonVisualNavigation {...visualNavigationProps} />
        </GridItem>
      </Grid>

      <Footer {...globalNavProps} />
    </>
  );
}
